import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { message, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { euPlatescPageHandler } from '../services/euplatesc-handler';

const ReInrolareButton = ({ user }) => {
  const { t } = useTranslation();

  const handleEnrollEmvCard = useCallback(
    (url, body) => {
      euPlatescPageHandler(url, body).catch((err) => {
        message.error({
          content: err?.inner?._
            ? t(err?.inner?._)
            : t('errors.enrollEmvCardError'),
          key: 'pos',
          duration: 5,
          className: 'card-message',
        });
      });
    },
    [t],
  );

  return (
    <Tooltip title={t('actions.changeCard')} key="changeCard">
      <div className="card-button">
        <button
          type="submit"
          onClick={() =>
            handleEnrollEmvCard(
              `${window._env_.API_BACKEND_URL}/portal/api/v1/enroll-card/${user.id}?x-tenant-key=${window._env_.API_TENANT_KEY}`,
              null,
            )
          }
        >
          <EditOutlined
            style={{
              fontSize: '3rem',
              color: '#d6f665',
              marginTop: '35%',
            }}
          />
        </button>
      </div>
    </Tooltip>
  );
};
export default ReInrolareButton;
